import { useEffect, useState } from 'react';
import React from 'react';
import ReactionStatsModal from '../../ui/ReactionStatsModal/index';

export function ReactionModalPlugin() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    nodeId: '',
    nodeText: ''
  });

  useEffect(() => {
    const events = ['openReactionModal'];
    const listeners = events.map((eventName) => {
      const listener = (e: CustomEvent) => {
        setModalState({
          isOpen: true,
          nodeId: e.detail.nodeId,
          nodeText: e.detail.nodeText
        });
      };
      document.addEventListener(eventName, listener);
      return { eventName, listener };
    });

    return () => {
      listeners.forEach(({ eventName, listener }) => {
        document.removeEventListener(eventName, listener);
      });
    };
  }, []);

  return (
    <ReactionStatsModal
      isOpen={modalState.isOpen}
      onClose={() => {
        requestAnimationFrame(() => {
          setModalState((prev) => ({ ...prev, isOpen: false }));
        });
      }}
      nodeId={modalState.nodeId}
    />
  );
}
